import React from 'react';
import { Avatar as MUIAvatar, Badge } from '@mui/material';
import { stringAvatar } from '@stack/helpers';

import { Props } from './props';
export const Avatar: React.FC<Props> = (props) => {
  const { src, alt, avatarProps, onClick, badgeIcon, name, ...restProps } =
    props;
  const { sx: avatarSx, children = '' } = stringAvatar(name ?? '');
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={badgeIcon ?? null}
      {...restProps}
      onClick={onClick}
    >
      <MUIAvatar
        alt={alt}
        src={src}
        {...avatarProps}
        sx={{
          ...(!src && avatarSx),
          ...avatarProps?.sx,
        }}
      >
        {src ? null : children}
      </MUIAvatar>
    </Badge>
  );
};

export * from './props';
export default Avatar;
